var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center w-full transition-opacity cursor-pointer hover:opacity-60 lg:justify-start"},[_c('div',{staticClass:"flex items-center gap-2",on:{"click":_vm.showCountrySelector}},[_c('CurrentCountryFlag'),_vm._v(" "),_c('CountryName'),_vm._v(" "),_c('ChevronIcon',{staticClass:"h-4"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }